import { render, staticRenderFns } from "./citizenList.vue?vue&type=template&id=365f2928&scoped=true"
import script from "./citizenList.vue?vue&type=script&lang=js"
export * from "./citizenList.vue?vue&type=script&lang=js"
import style0 from "./citizenList.vue?vue&type=style&index=0&id=365f2928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f2928",
  null
  
)

export default component.exports